import DeviceConnections from '../../../components/vehicle/device_connections'
import DeviceConnectionStore from '../../../components/vehicle/device_connections/context/context'

const DeviceConnectionPage = () => {
  return (
    <DeviceConnectionStore>
      <DeviceConnections />
    </DeviceConnectionStore>
  )
}

export default DeviceConnectionPage
